<template>
    <brick-octagon-base class="journey-brick" :class="classList" @click.native="handleClick">
        <template #content-top>
            <has-unseen-comments-marker class="has-unseen-comments-marker" v-if="hasUnseenComments" />
            
            <journey-brick-menu
                class="brick-dropdown-menu"
                :brick-id="id" 
            />
        </template>
        
        <template #icon>
            <brick-icon :brick-type="brick.type" />
        </template>
        
        <template #content-bottom>
            <component v-if="showSettings"
                       :is="editorType"

                       :brick="brick"
                       :show="showSettings"
                       @hidden="onSettingsHidden()"
                       @save="onSave($event)"
                       @delete="onDelete()"
            />

        </template>
    </brick-octagon-base>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import brickTypes from "@modules/JourneyBuilder/Bricks/brick-types";

    import journeyBrickMixin from '@modules/JourneyBuilder/Mixins/journey-brick'

    import BrickOctagonBase from '@modules/JourneyBuilder/Components/Patterns/BrickOctagonBase.vue';
    import BrickIcon from "./BrickIcon";
    import {ABTestSettings, AudienceFilterSettings} from "./Settings";
    import JourneyBrickMenu from "./BrickDropdownMenu";
    import {HasUnseenCommentsMarker} from "./Comments";

    const {mapGetters} = createNamespacedHelpers('journeyBuilder/composer');

    const brickTypeEditorMapping = {
        [brickTypes.audienceFilter]: AudienceFilterSettings,
        [brickTypes.abTest]: ABTestSettings
    };

    export default {
        name: 'brick-octagon',
        mixins: [journeyBrickMixin],
        components: {
            BrickOctagonBase,
            JourneyBrickMenu,
            HasUnseenCommentsMarker,
            BrickIcon
        },
        props: {
            /**
             * @type {JourneyBrick}
             */
            brick: {
                type: Object,
                required: true
            },

            isHighlighted: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            ...mapGetters(['menuShown']),
            ...mapGetters({
                'storeHasUnseenComments': 'hasUnseenComments'
            }),
            hasUnseenComments(){
                return this.storeHasUnseenComments(this.id);
            },
            editorType(){
                return brickTypeEditorMapping[this.type];
            },
            classList() {
                const vm = this;

                const list = [];

                list.push(vm.isActive ? 'active' : 'inactive');

                if(vm.isHighlighted){
                    list.push('highlighted');
                }

                if(vm.menuShown(vm.id)){
                    list.push('menu-dropdown-shown');
                }

                return list;
            },
            id(){
                return this.brick.id;
            }
        },
        data() {
            return {
                showSettings: false,
                prevX: 0,
                prevY: 0
            }
        },
        created() {
            this.prevX = this.x;
            this.prevY = this.y;
        },
        methods: {
            handleClick(){
                const vm = this;

                if(vm.x === vm.prevX && vm.y === vm.prevY){
                    vm.showSettings = true;
                }

                vm.prevX = vm.x;
                vm.prevY = vm.y;
            },

            onSettingsHidden(){
                this.showSettings = false;
            },

            onSave(evt){
                this.showSettings = false;
                this.$emit('settings-changed', evt);
            },

            onDelete(){
                const REQUIRES_PROMPT = false;

                this.showSettings = false;
                this.$emit('delete-brick', REQUIRES_PROMPT);
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/journey-brick-octagon.scss";
</style>